import { type UNSAFE_any } from '@flecto/types'

export function useCurrencyUtils() {
  return { floatToCents, floatToCurrency, centsToFloat, centsToCurrency }
}

function floatToCents(amount: number) {
  const str = amount.toString()
  const int = str.split('.')

  return Number(
    amount
      .toFixed(4)
      .replace('.', '')
      .padEnd(int.length === 1 ? 3 : 4, '0')
  )
}

function centsToFloat(cents: number) {
  const convertCents = cents / 10000
  return Number(convertCents.toFixed(2))
}

function floatToCurrency(amount: number, showCurrencySymbol = false) {
  const options: UNSAFE_any = {
    minimumFractionDigits: 2,
  }

  if (showCurrencySymbol) {
    options.style = 'currency'
    options.currency = 'EUR'
  }

  return amount.toLocaleString('pt', options)
}

function centsToCurrency(cents: number, showCurrencySymbol = false) {
  return floatToCurrency(centsToFloat(cents), showCurrencySymbol)
}
